import { apiClient } from './api-client';
import type { AnalyticsOverview } from '../types/analytics';

export async function fetchAnalyticsOverview(): Promise<AnalyticsOverview> {
  return apiClient<AnalyticsOverview>('/admin/analytics/overview');
}
